import { useEffect } from "react";
import { ListSkeleton } from "../../skeletons/List";
import { useState } from "react";
import { Container, Typography, Box, Tab, Tabs } from "@mui/material";
import FloatingActionButtons from "../../components/Fab";
import { useDashboardDrawer } from "../../providers/consumers/useDashboardDrawer";
import { useBuilder } from "../../../hooks/useBuilder";
import store, { clear, setFieldState } from "../../store/formStore";
import { useSelector } from "react-redux";
 import { ServerConfig } from "../../../connectors/Config";
import DataTable from "../../components/Table";
import moment from "moment";
import { AuthHelper } from "../../controllers/AuthHelper";


function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }

  
  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }
const ListAccreditamentoDocente = () => {
    const [certificates, setCertificates] = useState([]);
    const [loading, setLoading] = useState(false);
    const { pushMobileOpen, defaultOpen, addRouter } = useDashboardDrawer();
    const {builder, form, refs} = useBuilder();
    const [value, setValue] = useState(0);
    const [recensioni, setReviews] = useState([]);

    const handleChange = (event, newValue) => {
      setValue(newValue);
    };

    const findReviews = async() => {
      let user = await AuthHelper.getUserFromIdToken();

      const res = await fetch(`${ServerConfig.AWS.Serverless.API_BASE_URL_2}/domanda/docente/${user.Username}`);
      const json = await res.json();
      setReviews([...json]);
    }
    const elements = useSelector(state => state.elements);

    const columns = [
        { field: 'id', headerName: 'ID', width: 125, headerClassName: 'data-grid-header'},
        { field: 'nome_cognome_istruttore', headerName: 'Nome e cognome istruttore', width: 200, headerClassName: 'data-grid-header' },
        { field: 'data_di_nascita', headerName: 'Data di nascita', width: 200, headerClassName: 'data-grid-header' },
        { field: 'luogo_di_nascita', headerName: 'Luogo di nascita', width: 200, headerClassName: 'data-grid-header' },
        { field: 'codice_fiscale', headerName: 'Codice fiscale', width: 200, headerClassName: 'data-grid-header' },
        { field: 'indirizzo_residenza', headerName: 'Indirizzo residenza', width: 200, headerClassName: 'data-grid-header' },
        { field: 'numero_telefono_istruttore', headerName: 'Numero telefono istruttore', width: 200, headerClassName: 'data-grid-header' },
        { field: 'email_personale', headerName: 'Email personale', width: 200, headerClassName: 'data-grid-header' },
        { field: 'posizione_attuale', headerName: 'Posizione attuale', width: 200, headerClassName: 'data-grid-header' },
        { field: 'numero_anni_esperienza', headerName: 'Numero anni esperienza', width: 200, headerClassName: 'data-grid-header' },
        { field: 'competenze_specifiche', headerName: 'Competenze specifiche', width: 200, headerClassName: 'data-grid-header' },
        { field: 'tipologie_corsi_per_accreditamento', headerName: 'Tipologie corsi per accreditamento', width: 200, headerClassName: 'data-grid-header' },
        { field: 'titolo_studio', headerName: 'Titolo studio', width: 200, headerClassName: 'data-grid-header' },
        { field: 'certificati', headerName: 'Certificati', width: 200, headerClassName: 'data-grid-header' },
        { field: 'corsi_insegnati', headerName: 'Corsi insegnati', width: 200, headerClassName: 'data-grid-header' },
        { field: 'curriculum_file', headerName: 'Curriculum file', width: 200, headerClassName: 'data-grid-header', renderCell: (row) => <a href={row.value} target="_blank">Apri</a>},
        { field: 'certificazioni_file', headerName: 'Certificazioni file', width: 200, headerClassName: 'data-grid-header', renderCell: (row) => <a href={row.value} target="_blank">Apri</a> },
        { field: 'cover_letter_file', headerName: 'Cover letter file', width: 200, headerClassName: 'data-grid-header', renderCell: (row) => <a href={row.value} target="_blank">Apri</a> },
        { field: 'identita_file', headerName: 'Identita file', width: 200, headerClassName: 'data-grid-header', renderCell: (row) => <a href={row.value} target="_blank">Apri</a> },
        { field: 'createdAt', headerName: 'Data invio', width: 200, headerClassName: 'data-grid-header',valueGetter: (value) => moment(value).format('DD/MM/YYYY') }

    ];

    const getCertificates = async() => {
       
    }
    useEffect(() => {
        findReviews();
        store.dispatch(clear())
        builder('promo.add');
    }, [])

    const handleClick = (data, name = null) => {
        store.dispatch(clear())
        builder('teachers.accreditamento');
        if(data.row){
            Object.keys(data.row).forEach((key) => {
                store.dispatch(setFieldState({name: key, value: data.row[key]}));
            });
        }
        pushMobileOpen(true, 500, name ? name : "Crea Domanda", data.row);

    }

    return (<Container sx={{paddingLeft: 24, paddingRight: 24, minWidth: '100vw', marginTop: '3rem'}}>
    
    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
          <Tab label="Lista domande accreditamento docenti" {...a11yProps(0)} />
        </Tabs>
      </Box>
      <CustomTabPanel value={value} index={0}>
        {loading && <ListSkeleton />}
        {/* {!loading && <DataTable data={certificates} columns={columns} handleClick={handleClick} actions={[
            {type: 'select', name: 'Azioni'}
        ]}/>} */}
        {!loading && <DataTable data={recensioni} columns={columns} actions={[
        {type: 'select', name: 'Azioni'}
        ]}/>}
            <FloatingActionButtons onClick={() => handleClick([], "Crea Domanda")}/>

      </CustomTabPanel>
   
    
    </Container>);
}

export default ListAccreditamentoDocente;